import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IModalSuccessProps {}

export const ModalSuccess: FunctionComponent<IModalSuccessProps> = observer<FunctionComponent<IModalSuccessProps>>(function () {
    const { translateStore } = useStorageTranslateContext();

    let openModalSuccess = translateStore.openModalSuccess;

    return (
        <Dialog open={openModalSuccess} onClose={() => translateStore.handleCloseModalSuccess()} aria-describedby='alert-dialog-description'>
            <DialogContent>
                <DialogContentText id='alert-dialog-description'>Translation saved</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        translateStore.changeSetBeforeAccept.clear();
                        translateStore.handleCloseModalSuccess();
                    }}
                    size={'small'}
                    color='primary'>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
});
